import clsx from 'clsx';
import { useMemo } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

// Components
import LinkBase from '@/components/base/LinkBase';
import Icon from '@/components/base/Icon';
import NotificationsCounter from '@/components/base/NotificationsCounter';

// Hooks
import {
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    SCHEDULER_COLLABORATION_SETTINGS
} from '@/routes/privateRoutes';
import useCollaborationNotifications from '@/hooks/swr/useCollaborationNotifications';
import Loader from '@/components/base/Loader';

const CollaborationTabs = () => {
    const { t } = useTranslation('scheduler');
    const router = useRouter();
    const tabs = useMemo(
        () => [
            {
                name: t('collaboration.tabs.notifications'),
                icon: 'notification',
                url: SCHEDULER_COLLABORATION_NOTIFICATIONS
            },
            {
                name: t('collaboration.tabs.settings'),
                icon: 'settings',
                url: SCHEDULER_COLLABORATION_SETTINGS
            }
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
    const { notifications, isLoadingInitialData } = useCollaborationNotifications({
        limit: 20
    });

    return (
        <div role="tablist" className="tab-list flex items-center space-x-9">
            {Object.values(tabs).map((tab, index) => (
                <LinkBase
                    key={index}
                    href={tab.url}
                    className="relative flex items-center font-GBold text-3.5xl">
                    <span
                        className={clsx('flex items-center', {
                            'opacity-30': router?.route !== tab.url
                        })}>
                        <Icon
                            className={clsx('mr-3 text-xl', {
                                'text-icoBlue': router?.route === tab.url
                            })}
                            icon={tab.icon}
                        />
                        {tab.name}
                    </span>
                    {tab.url !== SCHEDULER_COLLABORATION_SETTINGS && (
                        <NotificationsCounter className="absolute -right-5 -top-2.5 flex items-center justify-center">
                            {isLoadingInitialData ? (
                                <Loader className="h-2 w-2 text-white" />
                            ) : (
                                notifications?.[0]?.summary?.unread_count ?? 0
                            )}
                        </NotificationsCounter>
                    )}
                </LinkBase>
            ))}
        </div>
    );
};

export default CollaborationTabs;
